import graphql__5e73127b131796d6a8e9 from "./__generated__/CreateTeamContactDialogMutation.graphql.ts";import * as React from "react";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {CreateTeamContactDialogMutation} from "./__generated__/CreateTeamContactDialogMutation.graphql";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type CreateTeamContactDialogProps = {
    handleCloseDialog: () => {}
}

const CreateTeamContactDialog: React.FC<CreateTeamContactDialogProps> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateTeamContactDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__5e73127b131796d6a8e9,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                    navigate('/contacts/' + response.createTeamContact?.id);
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateTeamContact'})
            }
        )
    }

    const initialValues = {}
    const validationSchema = yup.object().shape({
        teamName: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .matches(/^[\w,\-+&!?/ ()*.\\'äàáâæãåāéèêëėîïíīìöôòóõœøōüûùúūßśšñńçćčÿÄÀÁÂÆÃÅĀÉÈÊËĖÎÏÍĪÌÖÔÒÓÕŒØŌÜÛÙÚŪSSŚŠÑŃÇĆČŸ]{2,255}$/u, intl.formatMessage({id: 'validation.field.nameContainsInvalidCharacters'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        emailAddress: yup.string()
            .max(255, intl.formatMessage({id: 'validation.field.emailAddressTooLong'}))
            .email(intl.formatMessage({id: 'validation.field.emailAddressInvalid'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        phoneNumber: yup.string() // The ITU E.164 states that phone numbers around the globe are recommended to not be longer than 15 digits, but we allow more digits to be safe
            .max(20, intl.formatMessage({id: 'validation.field.phoneNumberTooLong'}))
            .matches(/^(\+(?:[0-9] ?){6,19}[0-9])?$/, intl.formatMessage({id: 'validation.field.phoneNumberInvalid'}))
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.teamName'})}</Label>
                    <Field name="teamName" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.teamNamePlaceholder'})} autoFocus={true}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.emailAddress'})}</Label>
                    <Field name="emailAddress" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.emailPlaceholder'})}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.phoneNumber'})}</Label>
                    <Field name="phoneNumber" type="text" placeholder={intl.formatMessage({id: 'dialog.CreateTeamContactDialog.phonePlaceholder'})}/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateTeamContactDialog;
